import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Format integer pence as a localised currency string. Never does float arithmetic.
 *
 * GUARDED, because `currency` comes from the DATABASE, not from a literal: `Intl` throws a
 * RangeError on a code it does not know, and an uncaught throw inside render takes the whole
 * screen to the error boundary over a formatting problem. `TimesheetScreen` carried its own
 * copy of this function WITH the guard while the shared one went without — so the safer
 * behaviour existed on exactly one screen. The guard belongs here, where every caller gets it.
 */
export function formatPence(pence: number, currency = 'GBP'): string {
  try {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
    }).format(pence / 100);
  } catch {
    return `${(pence / 100).toFixed(2)} ${currency}`;
  }
}
